"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = require("./Item.style");
var _menuItems = require("../../../../../../constants/menuItems");
var _Text = _interopRequireDefault(require("../../../../../Text"));
var _Link = _interopRequireDefault(require("../Link/Link.render"));
var _Parent = _interopRequireDefault(require("../Parent"));
var _RequestTool = require("../RequestTool");
const NavItem = _ref => {
  let {
    testSectionKey,
    subMenu,
    text,
    onClick,
    link,
    type,
    newTab,
    customRender,
    code,
    metadata,
    icon,
    ModalComp,
    ...rest
  } = _ref;
  if (subMenu && subMenu.length > 0 || customRender === _menuItems.CUSTOM_DROPDOWN_COMMODITIES || customRender === _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES) {
    return /*#__PURE__*/_react.default.createElement(_Parent.default, {
      title: text,
      onClick: onClick
    });
  }
  if (type === 'DropDownColumn') {
    return /*#__PURE__*/_react.default.createElement(_Item.Container, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "Body",
      variant: "Pills",
      intlText: text
    }));
  }
  if (type === 'SalesForce' && code) {
    return /*#__PURE__*/_react.default.createElement(_RequestTool.RequestToolItem, {
      code: code,
      metadata: metadata,
      text: text || 'General.Error',
      icon: icon,
      ModalComp: ModalComp
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Link.default, Object.assign({
    text: text,
    link: link,
    type: type,
    newTab: newTab,
    testSectionKey: testSectionKey
  }, rest));
};
var _default = exports.default = NavItem;